<div
  class="subview white-bg nordic-blue-900-text transition-appear"
  *ngIf="subViewVisibleDelayed$ | async"
  [class.is-vishidden]="(subViewVisibleDelayed$ | async) === false"
  [class.transition-appear--active]="subViewVisible$ | finDelay | async"
  [attr.aria-labelledby]="labelledBy"
  (keyup.esc)="shouldCloseSubview.emit()"
  role="dialog"
>
  <div class="grow flex flex--column">
    <header class="modal-header flex--nogrow fill relative">
      <ng-content select="header"></ng-content>
    </header>

    <div class="subview-content-wrapper flex-1 grow" [class.scroll]="enableScroll">
      <ng-container
        *ngIf="
          (ancillaryLoader$ | async) !== null && (ancillaryLoader$ | async) !== AncillaryLoaderStatus.OFF;
          else mainContent
        "
      >
        <fin-loader
          class="font-body-1 grow flex flex--center"
          [type]="LoaderType.EMBEDDED"
          [title]="'ancillaries.seats.reassigningYourSeats'"
        ></fin-loader>
      </ng-container>

      <ng-template #mainContent>
        <ng-content select="main-content"></ng-content>
      </ng-template>
    </div>
  </div>

  <ng-content select="global-content"></ng-content>
</div>
